import _ from 'lodash';
import Vue from 'vue';

export default {
    async initLoginUser (store, loginInfo) {
        let commit = store.commit;
        let info = loginInfo;

        if(!info || !info.admin) {
            info = await jzlWebApi.admin.getLoginAdmin();
        }

        if(!info || !info.admin) return;

        let admin = _.get(info, 'admin');
        let project = _.get(info, 'project');
        let customer = _.get(info, 'customer');
        let token = _.get(info, 'token');
        let loginType = _.get(info, 'loginType');

        if(admin) commit('INIT_LOGIN_USER', admin);
        if(project) commit('INIT_CURRENT_PROJECT', project);
        if(customer) commit('INIT_LOGIN_CUSTOMER', customer);
        if(loginType) commit('INIT_LOGIN_TYPE', customer);
        // if(token) commit('INIT_TOKEN', token);
        // this.$utils.setToken(token);
        // this.initToken({ commit }, token);
        if(token) await store.dispatch('initToken', token);

        store.dispatch('initTitleFavicon', project);
    },
    initLoginCust: async ({ commit }, loginInfo) => {
        let info = loginInfo;

        if(!info || !info.customer) {
            info = await jzlWebApi.admin.getLoginCust();
        }

        if(!info || !info.admin) return;

        let admin = _.get(info, 'admin');
        let project = _.get(info, 'project');
        let customer = _.get(info, 'customer');
        let token = _.get(info, 'token');
        let loginType = _.get(info, 'loginType');

        if(admin) commit('INIT_LOGIN_USER', admin);
        if(project) commit('INIT_CURRENT_PROJECT', project);
        if(customer) commit('INIT_LOGIN_CUSTOMER', customer);
        if(loginType) commit('INIT_LOGIN_TYPE', customer);
        if(token) store.dispatch('initToken', token);

        store.dispatch('initTitleFavicon', project);
    },
    initToken({ commit }, token) {
        if(!token) return;
        commit('INIT_TOKEN', token);
        //this.$utils.setToken(token);
        if(Vue.prototype.$utils && Vue.prototype.$utils.setToken) {
            Vue.prototype.$utils.setToken(token);
        }
    },
    initTitleFavicon({ commit }, project) {
        if(project) {
            let plogo = _.get(project, "project_logo");
            let pico = _.get(project, "project_ico");
            let pname = _.get(project, "project_name");

            if(Vue.prototype.$utils && Vue.prototype.$utils.setTitleFavicon) {
                Vue.prototype.$utils.setTitleFavicon(pname, pico || plogo);
            }
        }
    },
    changeProject: ({ commit }, project) => {
        commit('CHANGE_PROJECT', project);
    },
    menuToggle: ({ commit }, val) => {
        commit('CHANGE_MENUCOLLAPSE', val);
    },
    dyncCompLoadedTag: ({ commit }, domain) => {
        commit('DYNC_COMP_LOADED_TAG', domain);
    },
    getGroupsAndContentsByParentId: async ({ commit }, gid) => {
        let data = await jzlWebApi.admin.getAdminMenuByParentGroup(gid);
        return data;
    },
    changeMainMenu: ({ commit }, mainMenu) => commit('CHANGE_MAIN_MENU', mainMenu),
    /*initMenus: async ({ commit }, pid) => {
        let data = await jzlWebApi.admin.getAdminMenuTree(pid);
        if(data) {
            commit('INIT_MENUS', _.get(data, 'contents'));
            commit('INIT_MENU_GROUPS', _.get(data, 'groups'));
        }
    },*/
    initMenus: async ({ commit }) => {
        let menus = await jzlWebApi.menu.getSubMenuTree(-1, 1);
        // 排序优先级：是否首页在最前(多个根据序号) > 页面(多个根据序号) > 目录
        let dftMenus = _.filter(menus, m => {
            return !m.group_id && m.content_id && m.is_default_menu === 1;
        });
        /*let groups = _.filter(menus, m => {
            return m.group_id;
        });*/

        let normalMenus = _.filter(menus, m => {
            return !m.group_id && m.content_id && m.is_default_menu !== 1;
        });

        let realMenus= _.concat(dftMenus, normalMenus, { tid: "APPS", group_name: "应用", icon: { iconfont: "fa fa-app-store" } });
        if(realMenus) {
            commit('INIT_MENUS', realMenus);
        }
    },
    changeSubGroups: ({ commit }, subGroups) => {
        commit('CHANGE_SUBGROUPS', subGroups);
    }
}
